import { render, staticRenderFns } from "./EnvelopePrimaryActions.vue?vue&type=template&id=8ff39ea2"
import script from "./EnvelopePrimaryActions.vue?vue&type=script&lang=js"
export * from "./EnvelopePrimaryActions.vue?vue&type=script&lang=js"
import style0 from "./EnvelopePrimaryActions.vue?vue&type=style&index=0&id=8ff39ea2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports